import { Browser } from 'framework/ui/BrowserWarningNotification';

// Review supported browser versions periodically and update as needed.
export const MIN_SUPPORTED_BROWSER_VERSIONS: Record<Browser, number> = {
  [Browser.CHROME]: 90,
  [Browser.FIREFOX]: 90,
  [Browser.SAFARI]: 18,
  [Browser.EDGE]: 90,
  [Browser.UNKNOWN]: Number.MAX_SAFE_INTEGER,
};
